import Form from './form'

export default {
  icon: 'hashtag',
  label: 'Dial By Extension',
  type: 'voice',
  action: 'dialbyextension',
  form: Form
}
